<template>
   <v-app>
    <div class="hello2 rspnsv">
      <v-container fluid grid-list-md>
          <v-layout row wrap>
              <v-flex md12 sm8 xs12 style="text-align:center;padding-top: 200px;padding-right: 20px">
                  <div class="opct">
                      <v-icon color="#ff336d" size="50">help_outline</v-icon>
                      <h2 class="white--text">How can I help you?</h2>
                      <h3 class="white--text">Call Us</h3>
                      <p class="white--text contact_tag">+91-96747 39744</p>
                      <h3 class="white--text">or Email Us</h3>
                      <p class="white--text contact_tag">bishnutoursandtravels@gmail.com</p>
                  </div>
              </v-flex>

              <!-- <v-flex md4 sm4 xs12 class="help" style="padding-top: 70px;padding-right: 20px">
                  <v-container>
                      <v-card class="elevation-5 opct">
                          <h2 style="text-align:center;padding-top:20px;" class="enquiry">Drop us a line</h2>
                          <p style="text-align:center; color:#ff336d" class="contact_tag">We’d love to hear from you</p>
                            <v-form ref="form1"  lazy-validation>
                            <v-layout row wrap>
                                <v-flex xs12 md2 sm2></v-flex>
                         <v-flex xs12 md8 sm8>
                           <v-text-field  label="Name"></v-text-field>

                           <v-text-field  label="Email"></v-text-field>

                           <v-text-field type="Number"  label="Phone number"></v-text-field>

                           <v-textarea  label="Comment" ></v-textarea>
                         </v-flex>

                         <v-flex xs12 md2 sm2></v-flex>

                         <br>

                         <v-flex xs12 md2 sm2></v-flex>
                         <v-flex xs12 md8 sm8>
                           <v-btn style="margin-bottom:30px" color="#ff336d" class="white--text" large block depressed @click="enquiry()">Submit</v-btn>
                         </v-flex>

                         <v-flex xs12 md2 sm2></v-flex>
          
                       </v-layout>
                     </v-form>
                      </v-card>
                   </v-container>
                             </v-flex> -->
                         </v-layout>
                         
              </v-container>
    </div>

      <v-container style="max-width: 1400px; margin-top: 40px;">
        <div class="contact-heading">
           <h1>Contact Us</h1>
        </div>
        <v-layout row wrap style=" margin-top: 40px;">

            <v-flex xs12 md3 sm12 style="padding-right: 10px;text-align: center;" >
              <v-card style="padding-top: 30px;">
                <h5 style="color: #024C94;">L T. ANANDA ADHIKARY</h5>
                <h5 >Organised by</h5>
                <h5 style="color: #024C94;">ANUPAM ADHIKARY</h5>
                <div class="" style="text-align: center; margin-top: 15px;">
                  <v-icon style=" margin-right: 10px;" large color="#024C94">phone</v-icon>
                  <h5 style="margin-bottom: 0px;">9331039512 <br> 9674739744</h5>
                </div>
              </v-card>
            </v-flex>
            <v-flex xs12 md4 sm12 style="padding-right: 10px;" >
              <v-card style="padding-top: 30px;">
                <h1 style="text-align: center;">HEAD OFFICE   </h1>
                <h5 style="text-align: center;">KAMALALAYA CENTRE</h5>
                <p >Address: Room No. F 66, 1st Floor
                   156A, Lenin Sarani, Kolkata - 700 013</p>
                   <div class="" style="display:flex; align-items: center; margin-top: 15px;">
                  <v-icon style=" margin-right: 10px;" large color="#024C94">phone</v-icon>
                  <h5 style="margin-bottom: 0px;">2215-9501 <br> 9674739744</h5>
                </div>
                   <div class="" style="display:flex; align-items: center; margin-top: 15px;  margin-bottom: 15px;">
                  <v-icon style=" margin-right: 10px;" large color="#024C94">email</v-icon>
                  <h5 style="margin-bottom: 0px;">info@bishnutoursandtravels.in <br> bishnutoursandtravels@gmail.com</h5>
                </div>
                
              </v-card>
            </v-flex>
            <v-flex xs12 md5 sm12 >
              <v-card style="padding:20px; ">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.410934732062!2d88.35258808721971!3d22.563728926635186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a02770757b47565%3A0xfd248d501db26fb7!2s156a%2C%20Lenin%20Sarani%20Rd%2C%20Esplanade%2C%20Dharmatala%2C%20Taltala%2C%20Kolkata%2C%20West%20Bengal%20700013!5e0!3m2!1sen!2sin!4v1685618186823!5m2!1sen!2sin" width="100%" height="300px" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </v-card>

            </v-flex>
        </v-layout>
      </v-container>

      <v-container style="max-width: 1400px;margin-top: -200px;">
        <div class="contact-heading">
           <h1>BRANCH OFFICE</h1>
        </div>

        <v-layout row wrap>
          <v-flex xs12 md4 sm12 style="padding: 10px;">
            <v-card style="height: 200px;">
              <v-container>
                <h4>Location: CHANCHAL</h4>
                <h5>Address : Bithindra Dey, Berhampur</h5>
                <h5><v-icon style=" margin-right: 10px;" large color="#024C94">phone</v-icon> 85978 80624 / 97333 15684</h5>
              </v-container>
            </v-card>
          </v-flex>

          <v-flex xs12 md4 sm12 style="padding: 10px;">
            <v-card style="height: 200px;">
              <v-container>
                <h4>Location: Murshidabad</h4>
                <h5>Address : Bithindra Dey, Berhampur</h5>
                <h5><v-icon style=" margin-right: 10px;" large color="#024C94">phone</v-icon> 94741 86460 / 83458 33863</h5>
              </v-container>
            </v-card>
          </v-flex>

        <!--  <v-flex xs12 md4 sm12 style="padding: 10px;">
            <v-card style="height: 200px;">
              <v-container>
                <h4>Location : Behala</h4>
                <h5>Address : Chanchal Kumar Saha, 4/2K/HH, Sarsuna Satellite Township, Kolkata-700 061</h5>
                <h5><v-icon style=" margin-right: 10px;" large color="#024C94">phone</v-icon>+91 72785 04909</h5>
              </v-container>
            </v-card>
          </v-flex> -->

          <v-flex xs12 md4 sm12 style="padding: 10px;">
            <v-card style="height: 200px;">
              <v-container>
                <h4>Location : Laketown</h4>
                <h5>Address : N. K. Das, 180/A, Jessore Road, Kolkata - 700 089</h5>
                <h5><v-icon style=" margin-right: 10px;" large color="#024C94">phone</v-icon>+91 93319 71707 / 93393 82944</h5>
              </v-container>
            </v-card>
          </v-flex>

          <v-flex xs12 md4 sm12 style="padding: 10px;">
            <v-card style="height: 200px;">
              <v-container>
                <h4>Location : DumDum</h4>
                <h5>Address : Mr. A. Adhikary, 263 R.N. Tagore Road, Kolkata - 700 077</h5>
                <h5><v-icon style=" margin-right: 10px;" large color="#024C94">phone</v-icon>+91 93310 39512</h5>
              </v-container>
            </v-card>
          </v-flex>

          <v-flex xs12 md4 sm12 style="padding: 10px;">
            <v-card style="height: 200px;">
              <v-container>
                <h4>Location : Ranaghat</h4>
                <h5>Address : Mr. Adhikary, Talpukur Para</h5>
                <h5><v-icon style=" margin-right: 10px;" large color="#024C94">phone</v-icon>+91 93310 39512</h5>
              </v-container>
            </v-card>
          </v-flex>
        <!--  <v-flex xs12 md4 sm12 style="padding: 10px;"></v-flex>
          <v-flex xs12 md4 sm12 style="padding: 10px;">
            <v-card style="height: 200px;">
              <v-container>
                <h4>Location : Adisaptagram, Station Road</h4>
                <h5>Address :Mr. Prasanta Mukherjee</h5>
                <h5><v-icon style=" margin-right: 10px;" large color="#024C94">phone</v-icon>+91 82409 82347 / 90387 10539</h5>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex xs12 md4 sm12 style="padding: 10px;"></v-flex> -->
        </v-layout>
      </v-container>


</v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
       
    };
  },
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Bree+Serif|Squada+One&display=swap');
</style>

<style scoped>
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 50px;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.enquiry {
    font-family: 'Bree Serif', serif;
}
.contact_tag {
  font-size: 16px;
}
.head-ofc p, .branch-ofc p {
  font-size: 18px;
  font-weight: 500;
}
.head-ofc, .branch-ofc  {
  margin: 15px;
  padding: 30px;
}
@media screen and (max-width: 763px) {
  .rspnsv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    background-position: center;
    background-size: cover;
  }
  .help {
    padding-right: 0px !important;
  }
}
</style>
